module.exports = __webpack_public_path__ + "49756564291d32b7efdfaedd344c6c6a.pdf";